<template>
  <!-- link to ainmation.css -->
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"/>
  <router-view v-slot="{Component}">

    <component :is="Component" />
  
  </router-view>

</template>



<script>



export default {
  name: 'App',
  components: {
}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;900&display=swap');

:root{
  --color-blue: #2367ED;
  --color-yellow: #FBAD18;
  --color-red: #EC2227;
  --color-white: #FAFBFA;
  --color-green: #3FF98E;
  --color-purple: #69369C;
  --color-dark-blue: #002371;

  --fontsize-desktop: fsmqldfk;
  font-family: 'Poppins', sans-serif;
}
html{
  overflow: hidden;
}
.main{
  z-index: -5;
  height: 100vh;
  display: block;
  overflow: hidden;
}
body{
  margin: 0;
  padding: 0;
  min-width: 270px;
  /* no scrolling */
  overflow: hidden;
  /* background-color: var(--color-blue); */
}


h1{
  color: var(--color-green);
  z-index: 5;
  font-size: 84px;
  line-height: 1em;
  padding: 0px;
  margin: 0px;
}
h2{
  color: var(--color-white);
  font-weight: 700;
  font-size: 25px;
  margin-bottom: 0px;
  text-align: center;
}
.section{
    display: flex;
    flex-direction: column;
    align-items: center; 
  }

p{
  font-weight: 700;
  /* width: 95vw; */
  text-align: center;
  font-size: 1rem;
  margin-top: 40px;
  opacity: 0;

  z-index: 2;

}
/* .click-section{
  overflow: hidden;
  position: absolute;
  bottom: 0;
  width: 100vw;
} */


@media (min-width: 900px){
  h1{
    font-size: 8.625rem;
    margin-left: -5px;
  }
  h2{
    text-align: left;
  }
  p{
    text-align: left;
    max-width: 815px;
    font-size: 1.875rem;
  }
  .section{
    align-items: stretch;
    margin-left: 40%;
    margin-top: 10%
  }

 
}





  
  .instruction-y{
    opacity: 0;

    position: absolute;
    bottom: 4%;
    z-index: 20;
    font-size: 11px;
    font-weight: 700;
}


  


  @keyframes appear {
    0%{opacity: 0;}
    100%{opacity: 1;}
  }



</style>
